// 配置文件
export default {
  appId: 1012, // 项目的ID，每个项目都不一样，由后端确定
  timeout: 60000, // 超时时间
  oem_key_sit: "SIT_4VjZdg19laDoIrut", // dev sit uat环境的key是一样的
  oem_key_uat: "SIT_4VjZdg19laDoIrut",
  oem_key_prod: "PROD_vE4qK4uP1pO5qD2t",
  eom_secret: "meicloud",
};
